import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ChangePasswordService } from '../../service/change-password.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthStorageService } from '../../service/auth-storage.service';
import { AuthField } from '../../../feature/auth/enum/auth-field.enum';
import { NavigationRoute } from '../../constant/navigation-route.constant';
import { AlertService } from '../../service/alert.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

  public passwordsDoNotMatch: boolean = false;
  public fields = AuthField;
  public formGroup: FormGroup;
  public submitted: boolean;
  public routes = NavigationRoute;

  constructor(
    public activeModal: NgbActiveModal,
    private changePasswordService: ChangePasswordService,
    private alertService: AlertService,
    private authStorageService: AuthStorageService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    const user = this.authStorageService.getAuthenticatedUser();
    this.formGroup = new FormGroup({
      [AuthField.IDENTIFICATION_TYPE]: new FormControl(user.identificationType, [Validators.required]),
      [AuthField.IDENTIFICATION]: new FormControl(user.identificationNumber, [Validators.required]),
      [AuthField.PASSWORD]: new FormControl(null, [Validators.required]),
      [AuthField.NEW_PASSWORD]: new FormControl(null, [Validators.required]),
      [AuthField.PASSWORD_CONFIRMATION]: new FormControl(null, [Validators.required]),
    }, { validators: this.checkPasswords })

  }

  public onChange() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    const values = this.formGroup.getRawValue();
    this.changePasswordService.changePassword(values).subscribe(() => {
      this.alertService.showSuccessful(
        'Se ha actualizado la contraseña exitosamente',
        'Importante'
      );
      this.activeModal.close();
    })
  }

  public get controls() {
    return this.formGroup.controls;
  }

  private checkPasswords(group: FormGroup) {
    console.log('group ', group)
    const oldPassword = group.get(AuthField.PASSWORD)?.value;
    const password = group.get(AuthField.NEW_PASSWORD)?.value;
    const confirmPassword = group.get(AuthField.PASSWORD_CONFIRMATION)?.value;
    if (password && confirmPassword) {
      const equals = password === confirmPassword;
      if (!equals) {
        group.get(AuthField.NEW_PASSWORD).setErrors({ 'required': true });
        group.get(AuthField.PASSWORD_CONFIRMATION).setErrors({ 'required': true });
      } else {
        group.get(AuthField.NEW_PASSWORD).setErrors(null)
        group.get(AuthField.PASSWORD_CONFIRMATION).setErrors(null)
      }
      if(equals && oldPassword == password) {
        return { sameToOld: true };
      }
      return equals ? null : { notSame: true };
    } else {
      return null;
    }
  }

}
